import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { WithClassName, WithDataName } from 'common/types'
import { Colors } from 'common-constants/colors'
import { Badge } from 'components/presentational/Badge/Badge'
import { DeletingClockSvg } from 'components/presentational/svg/DeletingClockSvg'

export const BadgeDeleting: FC<
  { width: number } & WithDataName & WithClassName
> = ({ width, className, ...rest }) => {
  return (
    <Parent
      width={width}
      icon={<DeletingClockSvg />}
      className={className}
      data-name={rest['data-name']}
      text={
        <FormattedMessage
          id="messenger.contact.deleting.title"
          defaultMessage="Удаляется"
        />
      }
    />
  )
}

export const Parent = styled(Badge)<{ width: number }>`
  background: linear-gradient(
    to ${(props) => props.theme.right},
    ${Colors.backgroundHoverLight} ${(props) => props.width}%,
    ${Colors.white} ${(props) => props.width}%
  );
  background-color: ${Colors.white};
  border: 1px solid ${Colors.backgroundHoverLight};
  color: ${Colors.dark};
`

Parent.defaultProps = {
  width: 100,
}
